import CustomTable from 'components/CustomTable';
import useUserApprovalData from 'hooks/tableData/useUserApprovalData';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import MsgBox from 'components/MsgBox/MsgBox';

const SLayout = styled.div`
    padding: 15px;
`;

const UserApproval = (props) => {
    const [warningMsg, setWarningMsg] = useState(null);
    
    const { rows, columns, getPendingApprovalUser } = useUserApprovalData({ ...props, setWarningMsg});

    useEffect(() => {
        getPendingApprovalUser();
        // eslint-disable-next-line
    }, []);

    return <SLayout>
        {warningMsg ? (
            <MsgBox
                type={warningMsg.type}
                message={warningMsg.message}
                footerActions={warningMsg.footerActions}
                title={warningMsg.title}
            />
        ) : null}
        <CustomTable columns={columns} rows={rows}/>
    </SLayout>;
};

export default UserApproval;
